export class cmsComponent {
  id: number;
  description: string;
  title: string;
  title2: string;
  size: number;
  position: number;
  color: number;
  imageName: string;
  imageURL: string;
  contentType: number;
  isActive: boolean;
  showImageInside: boolean;
  visibility: number;
  sortOrder: number;
  listOrder: number;
  listArrangement: number;
  isExternal: boolean;
  urlLink: string;
  creationDate: Date;
  createdBy: string;
}

export class cmsComponentImage {
  id: number;
  name: string;
  imageURL: string;
  size: number;
  creationDate: Date;
  createdBy: string;
}

export class cmsRow {
  component1: cmsComponent;
  component2: cmsComponent;
}

export class cmsComponentFolder {
  id: number;
  componentId: number;
  folderId: number;
  name: string;
  name2: string;
  contentType: number;
  showImageInside: boolean;
  icon: string;
  listOrder: number;

  // Media information
  mediaType: number;
  sourceType: number;
  mediaUrl: string;
  thumbnailUrl: string;
  mediaName: string;
  title: string;
  title2: string;
}
export class cmsComponentLink {
  id: number;
  componentId: number;
  folderId: number;
  name: string;
  name2: string;
  url: string;
  icon: string;
}

export class cmsComponentText {
  id: number;
  componentId: number;
  folderId: number;
  textContent: string;
  textContent2: string;
  buttonName1: string;
  buttonName12: string;
  buttonUrl1: string;
  buttonName2: string;
  buttonName22: string;
  buttonUrl2: string;
  buttonName3: string;
  buttonName33: string;
  buttonUrl3: string;
}

export class cmsComponentExtra {
  id: number;
  componentId: number;
  folderId: number;
  street: string;
  city: string;
  state: string;
  zip: string;
  calendarService: number;
  calendarLocation: number;
  allowRSVP: boolean;
  directURL: string;
}

export class cmsComponentMedia {

  id: number;
  componentId: number;
  folderId: number;

  mediaType: number; // 1 = Image, 2 = Video, 3 = Audio

  // 1 = Uploaded file
  // 2 = YouTube
  // 3 = External URL
  sourceType: number;

  mediaUrl: string;
  thumbnailUrl: string;

  mediaName: string;

  title: string;
  title2: string;

  description: string;
  description2: string;

  creationDate: Date;
}